(function () {
  'use strict';

  var SELECTOR = 'form.screwman-stage14-product-form, form.screwman-card-cart[data-screwman-ajax-cart]';

  function routesValue(name, fallback) {
    return window.routes && window.routes[name] ? window.routes[name] : fallback;
  }


  var cartToastTimer = null;
  var cartToastResizeBound = false;

  function getCartToast() {
    var toast = document.getElementById('screwman-cart-toast');
    if (toast) return toast;

    toast = document.createElement('a');
    toast.id = 'screwman-cart-toast';
    toast.className = 'screwman-cart-toast';
    toast.href = routesValue('cart_url', '/cart');
    toast.setAttribute('aria-label', 'Added to cart. View cart.');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = [
      '<span class="screwman-cart-toast__check" aria-hidden="true">&#10003;</span>',
      '<span class="screwman-cart-toast__copy">',
      '<span class="screwman-cart-toast__title">Added to cart</span>',
      '<span class="screwman-cart-toast__link">View cart</span>',
      '</span>',
      '<span class="screwman-cart-toast__arrow" aria-hidden="true">&#8250;</span>'
    ].join('');
    document.body.appendChild(toast);

    toast.addEventListener('mouseenter', function () {
      if (cartToastTimer) window.clearTimeout(cartToastTimer);
    });
    toast.addEventListener('mouseleave', function () {
      scheduleCartToastClose(toast, 1800);
    });

    if (!cartToastResizeBound) {
      cartToastResizeBound = true;
      window.addEventListener('resize', function () {
        var current = document.getElementById('screwman-cart-toast');
        if (current && current.classList.contains('is-visible')) positionCartToast(current);
      }, { passive: true });
      window.addEventListener('scroll', function () {
        var current = document.getElementById('screwman-cart-toast');
        if (current && current.classList.contains('is-visible')) positionCartToast(current);
      }, { passive: true });
    }

    return toast;
  }

  function positionCartToast(toast) {
    var cartLink = document.querySelector('#cart-icon-bubble');
    var viewportPadding = window.innerWidth < 750 ? 10 : 16;
    var top = viewportPadding;
    var right = viewportPadding;

    if (cartLink) {
      var rect = cartLink.getBoundingClientRect();
      top = Math.max(viewportPadding, Math.round(rect.bottom + 8));
      right = Math.max(viewportPadding, Math.round(window.innerWidth - rect.right));
    }

    toast.style.top = top + 'px';
    toast.style.right = right + 'px';
  }

  function scheduleCartToastClose(toast, delay) {
    if (cartToastTimer) window.clearTimeout(cartToastTimer);
    cartToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, delay || 4200);
  }

  function showCartToast() {
    var toast = getCartToast();
    toast.href = routesValue('cart_url', '/cart');
    positionCartToast(toast);
    if (cartToastTimer) window.clearTimeout(cartToastTimer);
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        positionCartToast(toast);
        toast.classList.add('is-visible');
        scheduleCartToastClose(toast, 4500);
      });
    });
  }

  function getMessageElement(form) {
    var message = form.querySelector('.screwman-ajax-add-message, .screwman-stage14-warning, .screwman-pack-warning');
    if (!message) {
      message = document.createElement('div');
      message.className = 'screwman-ajax-add-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      form.appendChild(message);
    }
    return message;
  }

  function setMessage(form, text, type) {
    var message = getMessageElement(form);
    message.hidden = !text;
    message.textContent = text || '';
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
    if (message._timer) window.clearTimeout(message._timer);
    if (text && type === 'success') {
      message._timer = window.setTimeout(function () {
        message.hidden = true;
        message.textContent = '';
        message.classList.remove('is-success');
      }, 2800);
    }
  }

  function setBusy(form, busy) {
    form.dataset.screwmanAdding = busy ? '1' : '0';
    var submit = form.querySelector('[type="submit"]');
    if (!submit) return;
    submit.disabled = !!busy;
    submit.setAttribute('aria-busy', busy ? 'true' : 'false');
    submit.classList.toggle('loading', !!busy);
  }

  function readableError(data) {
    if (!data) return 'Could not add this item to the cart.';
    var text = data.description || data.message || data.errors || '';
    if (typeof text === 'object') {
      text = Object.keys(text).map(function (key) {
        return Array.isArray(text[key]) ? text[key].join(', ') : String(text[key]);
      }).join(' ');
    }
    text = String(text || 'Could not add this item to the cart.');
    if (/only\s+50\s+items|due to availability/i.test(text)) {
      return text + ' This limit is being returned by Shopify for the Online Store sales channel, not by the theme.';
    }
    return text;
  }

  function replaceCartBubble(sectionHtml) {
    if (!sectionHtml) return false;
    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var source = parsed.querySelector('#cart-icon-bubble');
    var target = document.querySelector('#cart-icon-bubble');
    if (!source || !target) return false;
    target.replaceWith(source);
    return true;
  }

  function updateBubbleFromCart() {
    return fetch(routesValue('cart_url', '/cart') + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (!bubble && cart.item_count > 0) {
          var link = document.querySelector('#cart-icon-bubble');
          if (link) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            link.appendChild(bubble);
          }
        }
        if (bubble) {
          var visible = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
          if (visible) visible.textContent = cart.item_count;
          bubble.hidden = cart.item_count < 1;
        }
        document.dispatchEvent(new CustomEvent('screwman:cart-added', { detail: { cart: cart } }));
        return cart;
      });
  }

  function prepareFormData(form) {
    var data = new FormData(form);
    data.delete('return_to');
    data.set('sections', 'cart-icon-bubble');
    data.set('sections_url', window.location.pathname + window.location.search);
    return data;
  }

  function submit(form) {
    if (form.dataset.screwmanAdding === '1') return;

    var quantity = parseInt(String(new FormData(form).get('quantity') || '1'), 10);
    if (!Number.isFinite(quantity) || quantity < 1) {
      setMessage(form, 'Please enter a valid quantity.', 'error');
      return;
    }

    setBusy(form, true);
    setMessage(form, '', '');

    fetch(routesValue('cart_add_url', '/cart/add.js'), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: prepareFormData(form)
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.status || data.errors) throw new Error(readableError(data));
          return data;
        });
      })
      .then(function (data) {
        var replaced = data.sections && replaceCartBubble(data.sections['cart-icon-bubble']);
        return (replaced ? Promise.resolve() : updateBubbleFromCart()).then(function () {
          setMessage(form, 'Added to cart.', 'success');
          showCartToast();
          document.dispatchEvent(new CustomEvent('screwman:cart-added', { detail: { item: data } }));
        });
      })
      .catch(function (error) {
        setMessage(form, error && error.message ? error.message : 'Could not add this item to the cart.', 'error');
      })
      .finally(function () {
        setBusy(form, false);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest(SELECTOR);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    submit(form);
  }, true);
})();
